import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule, ChipModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { IconModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import {
  CheckBoxModule,
  FormFieldModule,
  InputsModule,
  RadioButtonModule,
  TextBoxModule,
} from '@progress/kendo-angular-inputs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { MenusModule } from '@progress/kendo-angular-menu';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { PopupModule } from '@progress/kendo-angular-popup';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { LabelModule } from '@progress/kendo-angular-label';

const SHARED_MODULES = [
  ProgressBarModule,
  GridModule,
  IndicatorsModule,
  ButtonModule,
  IconModule,
  LayoutModule,
  DropDownsModule,
  TextBoxModule,
  FormFieldModule,
  ChipModule,
  NotificationModule,
  GridModule,
  IndicatorsModule,
  ButtonModule,
  PopupModule,
  MenusModule,
  LayoutModule,
  CheckBoxModule,
  TooltipModule,
  DialogsModule,
  LabelModule,
  InputsModule,
  RadioButtonModule,
];

@NgModule({
  exports: [...SHARED_MODULES],
  imports: [CommonModule, ...SHARED_MODULES],
})
export class SharedKendoModule {}
